import React from 'react';
import { Vector3 } from 'three';

import { WebJoint } from '@paragon/contract-library';
import { LineSegment2D } from '@paragon/geometry-library';
import { secantOfSlope, slopeFromPoints } from '@paragon/utilities';

import { useAppDispatch, useAppSelector } from '../../components/hooks';
import { findAndCalculateSegmentGeometryAndWebJointLocation } from '../../library/profiles/profileManipulation';
import { regenerateTrussAndReselectWebJoint, shiftWebJointPosition } from '../../store/actions/profileActions';
import { getInsertingOrRewebbingProfile } from '../../store/selectors/profileSelectors';
import { NudgeHandle } from './NudgeHandle';

export const WebJointEditorHandle = ({ webJoint }: { webJoint: WebJoint }) => {
  const dispatch = useAppDispatch();

  const profile = useAppSelector(getInsertingOrRewebbingProfile);
  const { segmentGeometry, webJointLocation } = findAndCalculateSegmentGeometryAndWebJointLocation(
    profile,
    webJoint.guid,
  );

  let { basePoint, endPoint } = segmentGeometry;
  if (basePoint.x > endPoint.x) [basePoint, endPoint] = [endPoint, basePoint];
  const orientedWebJointSegment = new LineSegment2D(basePoint, endPoint);
  const snappingCoefficient = secantOfSlope(slopeFromPoints(basePoint.x, basePoint.y, endPoint.x, endPoint.y));

  const position = new Vector3(webJointLocation.x, webJointLocation.y, 0);

  return (
    <NudgeHandle
      editType="EditingWebJoint"
      leftRight
      moveCallback={(deltaX: number) => dispatch(shiftWebJointPosition(webJoint.guid, deltaX))}
      postEditCallback={() => dispatch(regenerateTrussAndReselectWebJoint(webJoint.guid))}
      position={position}
      size={4}
      coordinateUpDirection={orientedWebJointSegment.direction.rotateQuarterTurn()}
      snappingCoefficient={snappingCoefficient}
      settingsButton={{ type: 'Snapping', position: { x: 2, y: 2, z: 0 } }}
    />
  );
};
